const defaultState = {
    projects: [
        {
            id: 1,
            appHref: "https://g-nik1ta.github.io/to-do-list/",
            type_id: 3,
            preview: "to-do-list.jpg",
            technologies: ["HTML", "CSS", "JavaScript"],
        },
        {
            id: 2,
            appHref: "https://g-nik1ta.github.io/calculator/",
            type_id: 3,
            preview: "calculator.jpg",
            technologies: ["HTML", "CSS", "JavaScript"],
        },
        {
            id: 3,
            appHref: "https://g-nik1ta.github.io/weather-forecast-app/",
            type_id: 3,
            preview: "weather-forecast.jpg",
            technologies: ["HTML", "CSS", "JavaScript", "API"],
        },
        {
            id: 4,
            appHref: "https://g-nik1ta.github.io/golden-landing-page/",
            type_id: 2,
            preview: "golden.jpg",
            technologies: ["HTML", "CSS", "JavaScript"],
        },
        {
            id: 5,
            appHref: "https://g-nik1ta.github.io/my-neural-network/",
            type_id: 3,
            preview: "neural-network.jpg",
            technologies: ["HTML", "CSS", "JavaScript"],
        },
        {
            id: 6,
            appHref: "https://g-nik1ta.github.io/login-form/",
            type_id: 3,
            preview: "login-form.jpg",
            technologies: ["HTML", "CSS", "Sass"],
        },
        {
            id: 7,
            appHref: "https://g-nik1ta.github.io/animation-of-cube/",
            type_id: 3,
            preview: "animtaion-cubes.jpg",
            technologies: ["HTML", "CSS", "Sass"],
        },
        // {
        //     id: 8,
        //     appHref: '',
        //     type_id: 3,
        //     preview: '',
        //     technologies: ["HTML", 'CSS', 'Sass'],
        //     project_name: 'My Social network',
        //     duration_work: 'Oct 2022',
        //     project_description: 'Простая 3D анимация кубов с разными цветами и размерами без использования JavaScript кода.',
        // },
        {
            id: 9,
            appHref: "https://g-nik1ta.github.io/react-todo-list/",
            type_id: 3,
            preview: "react-to-do-list.jpg",
            technologies: ["React", "Redux", "HTML", "CSS", "Js", "Sass"],
        },
        // {
        //     id: 10,
        //     appHref: '',
        //     type_id: 3,
        //     preview: '',
        //     technologies: ["HTML", 'CSS', 'Sass'],
        //     project_name: 'Pizza website',
        //     duration_work: 'Oct 2022',
        //     project_description: 'Простая 3D анимация кубов с разными цветами и размерами без использования JavaScript кода.',
        // },
        {
            id: 11,
            appHref: "",
            type_id: 1,
            preview: "usermanagement.jpg",
            technologies: [
                "Vue",
                "Vuex",
                "Vuetify",
                "Sass",
                "HTML",
                "CSS",
                "JavaScript",
                "API",
                "SPA",
            ],
        },
        {
            id: 12,
            appHref: "https://g-nik1ta.github.io/react-web-shop/",
            type_id: 1,
            preview: "react-web-shop.jpg",
            technologies: [
                "React",
                "Redux",
                "Sass",
                "CSS",
                "HTML",
                "JavaScript",
                "Firebase",
                "Database",
                "API",
                "Authentication",
                "SPA",
            ],
        },
        {
            id: 13,
            appHref: "https://g-nik1ta.github.io/resume/",
            type_id: 2,
            preview: "resume.jpg",
            technologies: ["HTML", "CSS"],
        },
        {
            id: 14,
            appHref: "https://g-nik1ta.github.io/hounter-landing/",
            type_id: 2,
            preview: "hounter-landing.jpg",
            technologies: [
                "HTML",
                "CSS",
                "React",
                "Rexux",
                "JavaScript",
                "Figma",
            ],
        },
        {
            id: 15,
            appHref: "",
            type_id: 1,
            preview: "address-book.jpg",
            technologies: ["HTML", "CSS", "PHP", "MySQL", "Sass", "Database"],
        },
        {
            id: 16,
            appHref: "https://g-nik1ta.github.io/printing-landing/",
            type_id: 2,
            preview: "printing-landing.jpg",
            technologies: ["HTML", "CSS", "Sass", "React", "JavaScript"],
        },
        {
            id: 17,
            appHref: "https://popi-jewelry.com/",
            type_id: 1,
            preview: "jewelty.jpg",
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "HTML",
                "CSS",
                "Sass",
                "JavaScript",
                "jQuery",
                "phpMyAdmin",
                "Database",
            ],
        },
        {
            id: 18,
            appHref: "https://kyiv-realty.spekter.site/",
            type_id: 1,
            preview: "kyiv-realty.jpg",
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "HTML",
                "CSS",
                "Sass",
                "JavaScript",
                "jQuery",
                "phpMyAdmin",
                "Database",
            ],
        },
        {
            id: 19,
            appHref: "https://mododomus.cy/",
            type_id: 1,
            preview: "mododomus.jpg",
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "HTML",
                "CSS",
                "Sass",
                "JavaScript",
                "jQuery",
                "phpMyAdmin",
                "Database",
            ],
        },
        {
            id: 20,
            appHref: "https://premier-palace.spekter.site/",
            type_id: 1,
            preview: "premier-palace.jpg",
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "HTML",
                "CSS",
                "Sass",
                "JavaScript",
                "jQuery",
                "Telegram Bot",
                "phpMyAdmin",
                "Database",
            ],
        },
        {
            id: 21,
            // appHref: "https://market-house.kyiv.ua/",
            appHref: "",
            type_id: 1,
            preview: "market-house.jpg",
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "HTML",
                "CSS",
                "Sass",
                "JavaScript",
                "jQuery",
                "phpMyAdmin",
                "Database",
            ],
        },
        {
            id: 22,
            appHref: "https://spektrum.zp.ua/",
            type_id: 1,
            preview: "spektrum.jpg",
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "HTML",
                "CSS",
                "Sass",
                "phpMyAdmin",
                "Database",
            ],
        },
        {
            id: 23,
            appHref: "https://stomadeus.ck.ua/uk/",
            type_id: 1,
            preview: "stomadeus.jpg",
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "HTML",
                "CSS",
                "Sass",
                "JavaScript",
                "jQuery",
                "Telegram Bot",
                "phpMyAdmin",
                "Database",
                "Seo",
            ],
        },
        {
            id: 24,
            appHref: "",
            type_id: 1,
            preview: "lavbet.jpg",
            technologies: [
                "React",
                "Redux",
                "Redux toolkit",
                "HTML",
                "CSS",
                "Sass",
                "JavaScript",
                "jQuery",
                "SPA",
            ],
        },
        {
            id: 25,
            appHref: "",
            type_id: 1,
            preview: "proxy/1.jpg",
            images: [
                "proxy/1.jpg",
                "proxy/2.jpg",
                "proxy/3.jpg",
                "proxy/4.jpg",
            ],
            technologies: [
                "React",
                "JavaScript",
                "Node.js",
                "Express",
                "SSR",
                "Webpack",
                "Sass",
                "SPA",
                "API",
                "Babel",
            ],
        },
        {
            id: 26,
            appHref: "",
            type_id: 1,
            preview: "portal/1.jpg",
            images: [
                "portal/1.jpg",
                "portal/2.jpg",
                "portal/3.jpg",
                "portal/4.jpg",
            ],
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "React",
                "Redux",
                "JavaScript",
                "HTML",
                "CSS",
                "Sass",
                "Redux Toolkit",
                "SPA",
                "jQuery",
                "API",
            ],
        },
        {
            id: 27,
            appHref: "https://g-nik1ta.github.io/Finance-App/",
            type_id: 3,
            preview: "finance_app/1.jpg",
            images: [
                "finance_app/1.jpg",
                "finance_app/2.jpg",
                "finance_app/3.jpg",
                "finance_app/4.jpg",
                "finance_app/5.jpg",
                "finance_app/6.jpg",
            ],
            technologies: [
                "React",
                "Redux",
                "JavaScript",
                "Firebase",
                "Sass",
                "HTML",
                "CSS",
                "Redux Toolkit",
                "SPA",
                "API",
            ],
        },
        // {
        //     id: 10,
        //     appHref: '',
        //     type_id: 3,
        //     preview: '',
        //     technologies: ["HTML", 'CSS', 'Sass'],
        //     project_name: 'Chatas Bot trello',
        //     duration_work: 'Oct 2022',
        //     project_description: 'Простая 3D анимация кубов с разными цветами и размерами без использования JavaScript кода.',
        // },
        {
            id: 28,
            appHref: "",
            type_id: 1,
            preview: "profile_person/1.jpg",
            images: [
                "profile_person/1.jpg",
                "profile_person/2.jpg",
            ],
            technologies: [
                "Laravel",
                "PHP",
                "MySQL",
                "React",
                "Redux",
                "JavaScript",
                "Material UI",
                "HTML",
                "CSS",
                "Sass",
                "Redux Toolkit",
                "SPA",
                "API",
            ],
        },
        {
            id: 29,
            appHref: "https://bookshelf-pi.vercel.app/",
            type_id: 3,
            preview: "bookshelf/1.jpg",
            images: [
                "bookshelf/1.jpg",
                "bookshelf/2.jpg",
                "bookshelf/3.jpg",
                "bookshelf/4.jpg",
                "bookshelf/5.jpg",
            ],
            technologies: [
                "Vue",
                "Pinia",
                "JavaScript",
                "Tailwind",
                "Json Server",
                "Sass",
                "SPA",
                "API",
            ],
        },
        {
            id: 30,
            appHref: "",
            type_id: 1,
            preview: "nexchance/1.jpg",
            images: [
                "nexchance/1.jpg",
                "nexchance/2.jpg",
                "nexchance/3.jpg",
                "nexchance/4.jpg",
                "nexchance/5.jpg",
                "nexchance/6.jpg",
                "nexchance/7.jpg",
                "nexchance/8.jpg",
                "nexchance/9.jpg",
                "nexchance/10.jpg",
                "nexchance/11.jpg",
            ],
            technologies: [
                "Laravel",
                "PHP",
                "PostgreSQL",
                "Vue",
                "Vuetify",
                "Pinia",
                "JavaScript",
                "TypeScript",
                "Tailwind",
                "HTML",
                "CSS",
                "Sass",
                "SPA",
                "API",
                "Webpack",
                "WebSockets",
                "Babel",
                "Json",
                "Pretier",
                "CI/CD",
                "Vite",
            ],
        },
        {
            id: 31,
            appHref: "",
            // appHref: https://goseechat.com/en or "https://client.dev.goseechat.com",
            type_id: 1,
            preview: "goseechat/1.jpg",
            images: [
                "goseechat/1.jpg",
                "goseechat/2.jpg",
                "goseechat/3.jpg",
            ],
            technologies: [
                "React",
                "Redux",
                "JavaScript",
                "Tailwind",
                "Sass",
                "SPA",
                "API",
            ],
        },
        {
            id: 32,
            appHref: "",
            // appHref: "https://daniel-tp-dev.d.yeducoders.com/",
            type_id: 1,
            preview: "prelit/1.jpg",
            images: [
                "prelit/1.jpg",
                "prelit/2.jpg",
                "prelit/3.jpg",
                "prelit/4.jpg",
                "prelit/5.jpg",
            ],
            technologies: [
                "React",
                "JavaScript",
                "TypeScript",
                "Tailwind",
                "Sass",
                "SPA",
                "API",
            ],
        },
        {
            id: 33,
            appHref: "",
            // appHref: https://appify.link/ or "https://magic-pwa.com/" or "https://dev-a3f9c1.appify.link/" or "https://dev-a3f9c1.magic-pwa.com/",
            type_id: 1,
            preview: "appify/1.png",
            images: [
                "appify/1.png",
                "appify/2.png",
                "appify/3.png",
                "appify/4.png",
                "appify/5.png",
            ],
            technologies: [
                "Laravel",
                "PHP",
                "Vue",
                "Pinia",
                "JavaScript",
                "PostgreSQL",
                "Tailwind",
                "Sass",
                "Vite",
                "SQL",
                "Telegram Bot API",
                "Webpack",
                "cron",
                "SPA",
                "Blade",
                "API"
            ],
        },
    ],
    currentProject: null,

    projects_translations: [
        {
            id: 1,
            companyId: 1,
            lang: "ru",
            project_name: "Список дел",
            duration_work: "Авг 2022",
            project_description:
                'Простой проект, созданный в короткий срок для осваивания скиллов и улучшение навыков. Веб приложение предоставляет возможность создавать, редактировать и удалять задачи. Также присутствует фильтрация задач на "не завершенные" и "все". В добавок на сайте есть часы и календарь в реальном времени.',
        },
        {
            id: 2,
            companyId: 1,
            lang: "ua",
            project_name: "Список справ",
            duration_work: "Серп 2022",
            project_description:
                'Простий проект, створений протягом короткого періоду для здобуття навичок та їх покращення. Веб-додаток надає можливість створювати, редагувати та видаляти завдання. Додатково, є фільтрація завдань на "незавершені" та "всі". Крім того, на веб-сайті присутні годинник та календар у реальному часі.',
        },
        {
            id: 3,
            companyId: 1,
            lang: "en",
            project_name: "To do list",
            duration_work: "Aug 2022",
            project_description:
                'A simple project created within a short period for skill acquisition and improvement. The web application provides the ability to create, edit, and delete tasks. Additionally, there is task filtering for "incomplete" and "all" tasks. Moreover, the website features real-time clock and a calendar.',
        },

        {
            id: 4,
            companyId: 2,
            lang: "ru",
            project_name: "Калькулятор",
            duration_work: "Вер 2022",
            project_description:
                'Типичная идея для пет-проекта - калькулятор. Разработан функционал для переключения "светлой" и "темной" темы, выбор которой записывается в локальное хранилище. Доступны стандартные математические операции по типу умножения, деления, удаление символа и так далее.',
        },
        {
            id: 5,
            companyId: 2,
            lang: "ua",
            project_name: "Калькулятор",
            duration_work: "Сент 2022",
            project_description:
                'Типова ідея для пет-проекту - калькулятор. Реалізовано функціонал для перемикання між "світлою" та "темною" темами, вибрана тема зберігається в локальному сховищі. Доступні стандартні математичні операції, такі як множення, ділення, видалення символів та інші.',
        },
        {
            id: 6,
            companyId: 2,
            lang: "en",
            project_name: "Calculator",
            duration_work: "Sep 2022",
            project_description:
                'A typical idea for a pet project - a calculator. Functionality has been developed to switch between "light" and "dark" themes, with the chosen theme being saved to local storage. Standard mathematical operations such as multiplication, division, deletion of characters, and so on, are available.',
        },

        {
            id: 7,
            companyId: 3,
            lang: "ru",
            project_name: "Прогноз погоды",
            duration_work: "Вер 2022",
            project_description:
                'Прогноз погоды, который использует API для получения данных о ней. На сайте присутствует температура, влажность, скорость ветра, тип погоды и многое другое. Прогноз указан на текущий и последующие 4 дня. Имеется возможность переключения температуры из "Цельсия" в "Фаренгейт", а также можно узнать погоду по текущему местоположению. Также разработан адаптив под мобильные устройства.',
        },
        {
            id: 8,
            companyId: 3,
            lang: "ua",
            project_name: "Прогноз погоди",
            duration_work: "Сент 2022",
            project_description:
                'Прогноз погоди, який використовує API для отримання даних про неї. На сайті відображаються температура, вологість, швидкість вітру, тип погоди та інше. Прогноз надається на поточний день та на наступні 4 дні. Користувачі можуть перемикати температуру між "Цельсієм" та "Фаренгейтом", а також можуть перевірити погоду за поточним місцезнаходженням. Крім того, застосунок адаптований під мобільні пристрої.',
        },
        {
            id: 9,
            companyId: 3,
            lang: "en",
            project_name: "Weather forecast",
            duration_work: "Sep 2022",
            project_description:
                'A weather forecast application that utilizes an API to retrieve weather data. The website displays temperature, humidity, wind speed, weather condition, and more. The forecast is provided for the current day and the following 4 days. Users can switch between "Celsius" and "Fahrenheit" temperature units, and can also check the weather based on their current location. Additionally, the application is responsive and optimized for mobile devices.',
        },

        {
            id: 10,
            companyId: 4,
            lang: "ru",
            project_name: "Golden Landing",
            duration_work: "Вер 2022",
            project_description:
                "Одностраничный лендинг с использованием стандартных технологий. На сайте есть ховер эффекты, различные картинки, навигация, шапка, подвал, различные блоки, а также форма контаков.",
        },
        {
            id: 11,
            companyId: 4,
            lang: "ua",
            project_name: "Golden Landing",
            duration_work: "Сент 2022",
            project_description:
                "Односторінковий лендінг з використанням стандартних технологій. На сайті присутні ховер-ефекти, різноманітні зображення, навігація, заголовок, підвал, різні блоки, а також форма контактів.",
        },
        {
            id: 12,
            companyId: 4,
            lang: "en",
            project_name: "Golden Landing",
            duration_work: "Sep 2022",
            project_description:
                "A single-page landing page using standard technologies. The website features hover effects, various images, navigation, header, footer, various blocks, and a contact form.",
        },

        {
            id: 13,
            companyId: 5,
            lang: "ru",
            project_name: "Нейронная сеть",
            duration_work: "Вер 2022",
            project_description:
                'Нейросеть на JS с использованием библиотеки "brain-browser". На сайте есть холст для рисовки объектов и три кнопки с соответствующей инструкцией в которых подробно написано что делать. Нейросеть можеть распознавать два состояния "да или нет", "добрый смайлик или плохой", "цифра 1 или цифра 2" и так далее. Важная особенность веб приложения в том, что нейросеть вначале нужно обучить (чем больше, тем лучше) прежде чем ее испытывать.',
        },
        {
            id: 14,
            companyId: 5,
            lang: "ua",
            project_name: "Нейронна мережа",
            duration_work: "Сент 2022",
            project_description:
                'Нейромережа на JS з використанням бібліотеки "brain-browser". На сайті є полотно для малювання об\'єктів та три кнопки з відповідними інструкціями, у яких детально описано, що робити. Нейромережа може розпізнавати два стани, такі як "так чи ні", "радісний смайлик або сумний", "цифра 1 або цифра 2" і так далі. Важливою особливістю веб-додатка є те, що нейромережу спочатку потрібно навчити (чим більше, тим краще), перш ніж її тестувати.',
        },
        {
            id: 15,
            companyId: 5,
            lang: "en",
            project_name: "Neural network",
            duration_work: "Sep 2022",
            project_description:
                'A neural network in JS using the "brain-browser" library. The website features a canvas for drawing objects and three buttons with corresponding instructions detailing what to do. The neural network can recognize two states such as "yes or no", "happy smiley or sad", "digit 1 or digit 2", and so on. An important feature of the web application is that the neural network needs to be trained first (the more, the better) before testing.',
        },

        {
            id: 16,
            companyId: 6,
            lang: "ru",
            project_name: "Форма входа",
            duration_work: "Окт 2022",
            project_description:
                "Простая форма логина с двумя полями: имя пользователя и пароль. На сайте идет упор на стили, которые были написаны с помощью предпроцессора Sаss.",
        },
        {
            id: 17,
            companyId: 6,
            lang: "ua",
            project_name: "Форма входа",
            duration_work: "Жовт 2022",
            project_description:
                "Проста форма входу з двома полями: ім'я користувача та пароль. Сайт акцентується на стилях, які були написані за допомогою препроцесора Sаss.",
        },
        {
            id: 18,
            companyId: 6,
            lang: "en",
            project_name: "Login form",
            duration_work: "Oct 2022",
            project_description:
                "A simple login form with two fields: username and password. The website emphasizes styles, which were written using the Sаss preprocessor.",
        },

        {
            id: 19,
            companyId: 7,
            lang: "ru",
            project_name: "Анимационные кубы",
            duration_work: "Окт 2022",
            project_description:
                "Простая 3D анимация кубов с разными цветами и размерами без использования JavaScript кода.",
        },
        {
            id: 20,
            companyId: 7,
            lang: "ua",
            project_name: "Анімаційні куби",
            duration_work: "Жовт 2022",
            project_description:
                "Проста 3D анімація кубів з різними кольорами та розмірами без використання коду JavaScript.",
        },
        {
            id: 21,
            companyId: 7,
            lang: "en",
            project_name: "Animtaion cubes",
            duration_work: "Oct 2022",
            project_description:
                "Simple 3D cube animation with different colors and sizes without using JavaScript code.",
        },

        {
            id: 22,
            companyId: 9,
            lang: "ru",
            project_name: "Список дел на ReactJS",
            duration_work: "Нояб 2022",
            project_description:
                "Довольно простой список дел, однако с использованием фреймворка React и менеджера состояний Redux. Есть возможность записи и удаления различных задач. Стили написаны с помощью Sass.",
        },
        {
            id: 23,
            companyId: 9,
            lang: "ua",
            project_name: "Список справ на ReactJS",
            duration_work: "Лист 2022",
            project_description:
                "Досить простий список справ, проте створений з використанням фреймворка React та менеджера стану Redux. Є можливість додавання та видалення різних завдань. Стилі написані за допомогою Sass.",
        },
        {
            id: 24,
            companyId: 9,
            lang: "en",
            project_name: "To do list on ReactJS",
            duration_work: "Nov 2022",
            project_description:
                "A fairly simple to-do list, however, built using the React framework and state manager Redux. It includes features for adding and deleting various tasks. Styles are written using Sass.",
        },

        {
            id: 25,
            companyId: 11,
            lang: "ru",
            project_name: "Usermanagement",
            duration_work: "Нояб 2022 - Дек 2022",
            project_description:
                "Проект разработан с целью повышения квалификации, изучения новых технологий и улучшение старых. Проект подразумивает собой Frontend часть, связанный с Backend-ом с помощью различных API запросов, без которого сайт функционировать не будет. Сайт - это система управлением пользователями, их создание, редактрование, добавление ролей и настройка профилей. Веб-приложение создано на фреймворке Vue, используя Vuex, Vuetify и другие технологии.",
        },
        {
            id: 26,
            companyId: 11,
            lang: "ua",
            project_name: "Usermanagement",
            duration_work: "Лист 2022 - Груд 2022",
            project_description:
                "Проект розроблено з метою підвищення кваліфікації, вивчення нових технологій та поліпшення існуючих. Він включає фронтендну частину, пов'язану з бекендом за допомогою різних запитів API, без яких сайт не буде працювати. Сайт є системою управління користувачами, що включає створення, редагування користувачів, додавання ролей та налаштування профілів. Веб-додаток створений на фреймворку Vue з використанням Vuex, Vuetify та інших технологій.",
        },
        {
            id: 27,
            companyId: 11,
            lang: "en",
            project_name: "Usermanagement",
            duration_work: "Nov 2022 - Dec 2022",
            project_description:
                "The project is developed with the aim of improving qualifications, learning new technologies, and enhancing existing ones. It involves a Frontend part connected to the Backend via various API requests, without which the site will not function. The website is a user management system, involving user creation, editing, adding roles, and profile settings. The web application is built on the Vue framework, using Vuex, Vuetify, and other technologies.",
        },

        {
            id: 28,
            companyId: 12,
            lang: "ru",
            project_name: "Интернет-магазин",
            duration_work: "Янв 2023 - Апр 2023",
            project_description:
                "Проект разработан с целью повышения квалификации, изучения новых технологий и улучшение старых. Проект подразумивает собой Frontend часть, связанный с Backend-ом с помощью различных API запросов, без которого сайт функционировать не будет. Сайт - это система управлением пользователями, их создание, редактрование, добавление ролей и настройка профилей. Веб-приложение создано на фреймворке Vue, используя Vuex, Vuetify и другие технологии.",
        },
        {
            id: 29,
            companyId: 12,
            lang: "ua",
            project_name: "Інтернет-магазин",
            duration_work: "Січ 2023 - Квіт 2023",
            project_description:
                "Цей академічний проект призначений для демонстрації знань фреймворка React та інших технологій. У цьому інтернет-магазині ведеться робота з API, реалізовані різноманітні запити до сервера. В якості основи хмарного сховища було обрано Firebase, де зберігається база даних, а також багато фотографій. Передбачена автентифікація, включаючи через Facebook та Google. Також повністю функціонують форми покупки товару та зворотнього зв'язку, присутній пошук, сортування, фільтрація товарів та багато іншого.",
        },
        {
            id: 30,
            companyId: 12,
            lang: "en",
            project_name: "Web shop",
            duration_work: "Jan 2023 - Apr 2023",
            project_description:
                "This academic project is designed to demonstrate knowledge of the React framework and other technologies. This online store involves working with APIs, implementing various server requests. Firebase was chosen as the basis of the cloud storage, where the database and numerous photos are stored. Authentication is provided, including via Facebook and Google. Purchase and feedback forms are also fully functional, with search, sorting, filtering of products, and much more.",
        },

        {
            id: 31,
            companyId: 13,
            lang: "ru",
            project_name: "Мое резюме",
            duration_work: "Июль 2022 - Авг 2022",
            project_description:
                "Сайт представляет собой мое резюме, в котором содержится краткая информация обо мне, моем опыте работы, технологиях и образовании. Сайт адаптирован под разные размеры устройств. Проект использует минимальный набор технологий, такие как HTML и CSS.",
        },
        {
            id: 32,
            companyId: 13,
            lang: "ua",
            project_name: "Моє резюме",
            duration_work: "Лип 2022 - Січ 2022",
            project_description:
                "Сайт є моїм резюме, яке містить коротку інформацію про мене, мій досвід роботи, технології та освіту. Сайт адаптований під різні розміри пристроїв. Проект використовує мінімальний набір технологій, таких як HTML та CSS.",
        },
        {
            id: 33,
            companyId: 13,
            lang: "en",
            project_name: "My resume",
            duration_work: "Jul 2022 - Aug 2022",
            project_description:
                "This website is my resume, containing brief information about me, my work experience, technologies, and education. The site is responsive and adapts to various device sizes. The project uses a minimal set of technologies, such as HTML and CSS.",
        },

        {
            id: 34,
            companyId: 14,
            lang: "ru",
            project_name: "Hounter landing",
            duration_work: "Май 2023",
            project_description:
                "Это небольшой одностраничный лендинг, созданный на платформе React + менеджер состояния Redux, разработанный в течение короткого периода. Кроме того, здесь реализована адаптация под устройства с разными размерами экрана.",
        },
        {
            id: 35,
            companyId: 14,
            lang: "ua",
            project_name: "Hounter landing",
            duration_work: "Трав 2023",
            project_description:
                "Це невеликий односторінковий лендінг, створений на платформі React + менеджер стану Redux, розроблений протягом короткого періоду. Крім того, тут реалізовано адаптацію під пристрої з різними розмірами екрану.",
        },
        {
            id: 36,
            companyId: 14,
            lang: "en",
            project_name: "Hounter landing",
            duration_work: "May 2023",
            project_description:
                "This is a small single-page landing, created on the React platform + Redux state manager, developed within a short timeframe. Additionally, it features adaptation for devices with different screen sizes.",
        },

        {
            id: 37,
            companyId: 15,
            lang: "ru",
            project_name: "Адрессная книжка",
            duration_work: "Май 2023",
            project_description:
                "Данный проект разработан с целью освоения Backend технологий и этого направления в целом. В ходе написания сайта были изучены основы языка программирования PHP, SQL запросов, создания и работа с БД. В приложении имеется форма для создания и редактирования пользователей, поиск нужного по определенному полю, их удаление. Все данные записываются в базу данных и остаются там, даже после закрытия сайта.",
        },
        {
            id: 38,
            companyId: 15,
            lang: "ua",
            project_name: "Адресна книжка",
            duration_work: "Трав 2023",
            project_description:
                "Цей проект розроблено з метою освоєння Backend технологій і цього напрямку в цілому. Під час написання веб-сайту були вивчені основи мови програмування PHP, SQL запитів, створення та робота з базами даних. У додатку є форма для створення та редагування користувачів, пошук за певним полем та їх видалення. Усі дані зберігаються в базі даних і залишаються там навіть після закриття веб-сайту.",
        },
        {
            id: 39,
            companyId: 15,
            lang: "en",
            project_name: "Address book",
            duration_work: "May 2023",
            project_description:
                "This project is developed with the aim of mastering Backend technologies and this field in general. During the development of the website, the basics of the PHP programming language, SQL queries, and database creation and management were studied. The application includes a form for creating and editing users, searching by a specific field, and deleting them. All data is stored in the database and remains there even after closing the website.",
        },

        {
            id: 40,
            companyId: 16,
            lang: "ru",
            project_name: "Printing landing",
            duration_work: "Май 2023",
            project_description:
                "Это небольшой одностраничный лендинг, написанный на платформе React, который я сделал на основе макета из Photoshop. На этом сайте много разных блоков, а также есть слайдер. Кроме того, здесь соблюдена семантика и реализована адаптация под мобильную версию (320px).",
        },
        {
            id: 41,
            companyId: 16,
            lang: "ua",
            project_name: "Printing landing",
            duration_work: "Трав 2023",
            project_description:
                "Це невеликий односторінковий лендінг, написаний на платформі React, який я створив на основі макету з Photoshop. На цьому сайті багато різних блоків, а також є слайдер. Крім того, тут використана семантична розмітка та реалізована адаптація під мобільну версію (320px).",
        },
        {
            id: 42,
            companyId: 16,
            lang: "en",
            project_name: "Printing landing",
            duration_work: "May 2023",
            project_description:
                "This is a small single-page landing, written on the React platform, which I created based on a layout from Photoshop. The site contains many different blocks and a slider. Additionally, semantic markup is used, and adaptation for the mobile version (320px) is implemented.",
        },

        {
            id: 43,
            companyId: 17,
            lang: "ru",
            project_name: "Popi Jewelry",
            duration_work: "Июнь 2023 - Сент 2023",
            project_description:
                'Многофункциональный интернет-магазин детской бижутерии, который также является моим первым проектом использующий обширные возможности Backend, баз данных, работу с сервером и фреймворка Laravel. На сайте есть каталог различных категорий, поиск по товарам, мультиязычность, форма обратной связи, "плавающая кнопка социальных сетей" и многое другое. Кроме этого присутствует кастомная панель управления (админка), требущющая авторизации, которая предназначена для управления всего сайта, начиная от редактирования товаров и категорий, заканчивая работой над главным слайдером. При работе с данным проектом были изучены основы хостинга adm.tools и управлением над сайтами, которые размещены на нём.',
        },
        {
            id: 44,
            companyId: 17,
            lang: "ua",
            project_name: "Popi Jewelry",
            duration_work: "Черв 2023 - Вер 2023",
            project_description:
                'Багатофункціональний інтернет-магазин дитячого прикраси, який є моїм першим проектом, що використовує обширні можливості Backend, баз даних, роботу на сервері та фреймворк Laravel. На сайті є каталог різних категорій, пошук товарів, багатомовність, форма зворотнього зв\'язку, "плаваюча кнопка соціальних мереж" та багато іншого. Крім того, є власна панель керування (адмін панель), яка вимагає автентифікації і призначена для управління всім сайтом, починаючи з редагування товарів та категорій та закінчуючи роботою над головним слайдером. При роботі над цим проектом було вивчено основи хостингу на adm.tools та управління сайтами, розміщеними на ньому.',
        },
        {
            id: 45,
            companyId: 17,
            lang: "en",
            project_name: "Popi Jewelry",
            duration_work: "Jun 2023 - Sep 2023",
            project_description:
                'A multifunctional online store for children\'s jewelry, which is also my first project using extensive Backend capabilities, databases, server-side work, and the Laravel framework. The website features a catalog of various categories, product search, multilingualism, a feedback form, a "floating social media button," and much more. Additionally, there is a custom control panel (admin panel) that requires authentication, designed to manage the entire site, from editing products and categories to working on the main slider. Working on this project involved learning the basics of hosting on adm.tools and managing websites hosted on it.',
        },

        {
            id: 46,
            companyId: 18,
            lang: "ru",
            project_name: "Kyiv Realty",
            duration_work: "Июнь 2023 - Июль 2023",
            project_description:
                'Принимал участие в проекте "KYIV REALTY". Это сайт агнетсва недвижимости в Киеве, на котором присутствует такой функционал как: многоязычность, обширная панель фильтров, поиск, каталог объектов, различные формы обратной связи, множество слайдеров и т.д.',
        },
        {
            id: 47,
            companyId: 18,
            lang: "ua",
            project_name: "Kyiv Realty",
            duration_work: "Черв 2023 - Лип 2023",
            project_description:
                "Брав участь у проекті \"KYIV REALTY\". Це сайт агентства нерухомості в Києві, на якому присутні такі функції, як: багатомовність, обширна панель фільтрів, пошук, каталог об'єктів, різноманітні форми зворотного зв'язку, численні слайдери та інше.",
        },
        {
            id: 48,
            companyId: 18,
            lang: "en",
            project_name: "Kyiv Realty",
            duration_work: "Jun 2023 - Jul 2023",
            project_description:
                'Participated in the "KYIV REALTY" project. This is a real estate agency website in Kyiv, which includes features such as multilingualism, an extensive filter panel, search, property catalog, various feedback forms, multiple sliders, etc.',
        },

        {
            id: 49,
            companyId: 19,
            lang: "ru",
            project_name: "Mododomus",
            duration_work: "Июнь 2023 - Нояб 2023",
            project_description:
                'Сайт - портал по проектированию модульных домов в Европе. Присутствует уникальный функционал 3D панорам экстерьеров и интерьеров моделей домов с возможностью "перемещания" между точками для удобного осмотра дома со всех ракурсов, а также динамичное изменение цветов дома, комнат и их типов. В добавок ко всему перечисленному присутствует онлайн консультант, формы обратной связи, оформления заказа и подробная информация по моделям домов, самой компании и т.д.',
        },
        {
            id: 50,
            companyId: 19,
            lang: "ua",
            project_name: "Mododomus",
            duration_work: "Черв 2023 - Лист 2023",
            project_description:
                "Сайт - портал з проектування модульних будинків в Європі. Він має унікальний функціонал з 3D-панорами екстер'єрів та інтер'єрів моделей будинків, що дозволяє \"навігувати\" між точками для зручного перегляду будинку з усіх ракурсів, а також динамічні зміни кольорів будинку, кімнат та їх типів. Окрім усіх вищезазначених функцій, є онлайн-консультант, форми зворотного зв'язку, оформлення замовлення та детальна інформація про моделі будинків, саму компанію та інше.",
        },
        {
            id: 51,
            companyId: 19,
            lang: "en",
            project_name: "Mododomus",
            duration_work: "Jun 2023 - Nov 2023",
            project_description:
                'The website is a portal for designing modular homes in Europe. It features unique functionality with 3D panoramas of exteriors and interiors of house models, allowing for "navigation" between points for convenient viewing of the house from all angles, as well as dynamic color changes for the house, rooms, and their types. In addition to all the mentioned features, there is an online consultant, feedback forms, order placement, and detailed information about house models, the company itself, etc.',
        },

        {
            id: 52,
            companyId: 20,
            lang: "ru",
            project_name: "Premier Palace",
            duration_work: "Авг 2023 - Окт 2023",
            project_description:
                "Многофункциональный интернет-магазин по продаже мебели. Адаптивный сайт, имеющий такие разделы как: каталог, поиск, отдельная страница со скидами, услуги, контакты, текстовые страницы и прочие. Присутствует мультиязычность, удобная страница для оформления заказа, а также в сайт встроен Telegram Bot для удобной обратотки заказов, на который может подписаться меннеджер или админ по управлению над сайтом.",
        },
        {
            id: 53,
            companyId: 20,
            lang: "ua",
            project_name: "Premier Palace",
            duration_work: "Серп 2023 - Окт 2023",
            project_description:
                "Багатофункціональний інтернет-магазин меблів. Адаптивний веб-сайт, який має такі розділи, як каталог, пошук, окрема сторінка зі знижками, послуги, контакти, текстові сторінки та інше. Присутня багатомовність, зручна сторінка оформлення замовлення, а також веб-сайт вбудовує в себе Telegram Bot для зручної обробки замовлень, на який може підписатися менеджер або адміністратор сайту.",
        },
        {
            id: 54,
            companyId: 20,
            lang: "en",
            project_name: "Premier Palace",
            duration_work: "Aug 2023 - Oct 2023",
            project_description:
                "A multifunctional online furniture store. An adaptive website featuring sections such as a catalog, search, a separate page for discounts, services, contacts, text pages, and more. It includes multilingualism, a convenient checkout page, and a Telegram Bot integrated into the website for convenient order processing, which can be subscribed to by a manager or site administrator.",
        },

        {
            id: 55,
            companyId: 21,
            lang: "ru",
            project_name: "Market House",
            duration_work: "Септ 2023 - Окт 2023",
            project_description:
                "Интернет-магазин имеющий огромный ассортимент товаров, каталог поделеный на множество категорий и подкатегорий, система фильтров, поиск, формы обратной связи, мультиязычность и так далее.",
        },
        {
            id: 56,
            companyId: 21,
            lang: "ua",
            project_name: "Market House",
            duration_work: "Вер 2023 - Окт 2023",
            project_description:
                "Інтернет-магазин з величезним асортиментом товарів, каталог якого поділений на безліч категорій та підкатегорій, система фільтрів, можливість пошуку, форми зворотнього зв'язку, підтримка кількох мов тощо.",
        },
        {
            id: 57,
            companyId: 21,
            lang: "en",
            project_name: "Market House",
            duration_work: "Sep 2023 - Oct 2023",
            project_description:
                "An online store with a vast range of products, a catalog divided into numerous categories and subcategories, a filtering system, search functionality, feedback forms, multilingual support, and so on.",
        },

        {
            id: 58,
            companyId: 22,
            lang: "ru",
            project_name: "Spektrum",
            duration_work: "Июль 2023, Март 2024",
            project_description:
                "Сайт по изготовлению, продажи и монтажу различных окон и солнцезащитных конструкций. Подключал Telegram бота для удобного отслеживания заявок, а также работал с админкой, добавял новые категории, фотографии, текстовые данные.",
        },
        {
            id: 59,
            companyId: 22,
            lang: "ua",
            project_name: "Spektrum",
            duration_work: "Лип 2023, Март 2024",
            project_description:
                "Сайт з виготовлення, продажу та монтажу різних вікон та сонцезахисних конструкцій. Підключав Telegram бота для зручного відстеження заявок, а також працював з адмінкою, додавав нові категорії, фотографії, текстові дані.",
        },
        {
            id: 60,
            companyId: 22,
            lang: "en",
            project_name: "Spektrum",
            duration_work: "Jul 2023, Mar 2024",
            project_description:
                "Website for manufacturing, selling, and installing various windows and sun protection structures. I integrated a Telegram bot for convenient order tracking, and also worked with the admin panel, adding new categories, photos, and textual data.",
        },

        {
            id: 61,
            companyId: 23,
            lang: "ru",
            project_name: "Stomadeus",
            duration_work: "Нояь 2023 - Февр 2024",
            project_description:
                'Проект "стоматология" - проект над которым работал с самого начала и до выхода в продакшн. На сайте удобный интерфейс, имеется адаптив, мультиязычность, различные формы, слайдер, удобная админка, страница с отзывами, Telegram бот и многое другое. В работе с данным сайтом был получен уникальный опыт в работе с Seo, а именно встраивание различных мета тегов и атрибутов, улучшение page speed, создание sitemap, семантика, добавление микроразметки и аналатики, общая оптимизация и продвижения сайта в поисковых системах и так далее.',
        },
        {
            id: 62,
            companyId: 23,
            lang: "ua",
            project_name: "Stomadeus",
            duration_work: "Лист 2023 - Лют 2024",
            project_description:
                'Проект "стоматологія" - проект, над яким я працював від початку до випуску в продакшн. На сайті зручний інтерфейс, пристосованість до різних пристроїв, багатомовність, різноманітні форми, слайдер, зручна адмінка, сторінка з відгуками, Telegram бот і багато іншого. Робота над цим сайтом надала унікальний досвід у роботі з SEO, зокрема вбудовування різних мета-тегів та атрибутів, покращення швидкості сторінок, створення sitemap, семантика, додавання мікророзмітки та аналітики, загальна оптимізація та просування сайту в пошукових системах і багато іншого.',
        },
        {
            id: 63,
            companyId: 23,
            lang: "en",
            project_name: "Stomadeus",
            duration_work: "Nov 2023 - Feb 2024",
            project_description:
                'The "Dentistry" project - a project I worked on from inception to production. The website features a user-friendly interface, adaptability, multilingual support, various forms, sliders, a convenient admin panel, a testimonials page, a Telegram bot, and much more. Working on this site I gained unique experience in SEO, including embedding various meta tags and attributes, improving page speed, creating a sitemap, semantics, adding microdata and analytics, overall optimization, and website promotion in search engines, and more.',
        },

        {
            id: 64,
            companyId: 24,
            lang: "ru",
            project_name: "Lavbet",
            duration_work: "Окт 2023 - Февр 2024",
            project_description:
                "Букмекерский сайт спортинвых ставок. Один из лучших моих проектов на основе фреймворка React разработан по принципу Single Page Aplication. Сайт имеет возможность авторизации, в том числе и через социальные сети, переключение светлой/темной тем, поиск, множество категорий спорта, удобный интерфейс сайта, страницы профиля и многое другое. В качестве меннеджера состояния используется Redux, в котором хранятся почти все данные о сайте, начиная от информации про аккаунт пользователя, заканчивая списком категорий и матчей.",
        },
        {
            id: 65,
            companyId: 24,
            lang: "ua",
            project_name: "Lavbet",
            duration_work: "Жовт 2023 - Лют 2024",
            project_description:
                "Сайт спортивних ставок. Один з моїх кращих проектів на основі фреймворка React, розроблений за принципом Single Page Application. Сайт має можливість автентифікації, включаючи через соціальні мережі, перемикання світлої/темної теми, можливість пошуку, багато категорій спорту, зручний інтерфейс, сторінки профілю та багато іншого. Redux використовується як менеджер стану, в якому зберігається майже вся інформація про сайт, від інформації про обліковий запис користувача до списку категорій та матчів.",
        },
        {
            id: 66,
            companyId: 24,
            lang: "en",
            project_name: "Lavbet",
            duration_work: "Oct 2023 - Feb 2024",
            project_description:
                "A sports betting website. One of my best projects based on the React framework developed as a Single Page Application. The site features authentication, including via social networks, light/dark theme switching, search functionality, numerous sports categories, a user-friendly interface, profile pages, and much more. Redux is used as the state manager, storing almost all data about the site, from user account information to the list of categories and matches.",
        },

        {
            id: 67,
            companyId: 25,
            lang: "ru",
            project_name: "Proxy",
            duration_work: "Апр 2024 - Апр 2024",
            project_description:
                "Фронтенд-приложение, созданное на React с серверным рендерингом (SSR) с использованием Express.js. Сборка реализована через Webpack с полной совместимостью под Node.js 14. В качестве API использовался сервис jsonplaceholder.typicode.com. Реализована маршрутизация с возможностью копирования ссылок и последующего отображения нужного контента. Приложение включает поиск и сортировку пользователей по имени, отображение постов и альбомов пользователей, а также настройку meta-тегов для SEO.",
        },
        {
            id: 68,
            companyId: 25,
            lang: "ua",
            project_name: "Proxy",
            duration_work: "Квіт 2024 - Квіт 2024",
            project_description:
                "Фронтенд-додаток, створений на React із серверним рендерингом (SSR) з використанням Express.js. Складання реалізовано через Webpack з повною сумісністю під Node.js 14. Як API використовувався сервіс jsonplaceholder.typicode.com. Реалізовано маршрутизацію з можливістю копіювання посилань та подальшого відображення потрібного контенту. Додаток включає пошук та сортування користувачів по імені, відображення постів та альбомів користувачів, а також налаштування meta-тегів для SEO.",
        },
        {
            id: 69,
            companyId: 25,
            lang: "en",
            project_name: "Proxy",
            duration_work: "Apr 2024 - Apr 2024",
            project_description:
                "A frontend application built with React using server-side rendering (SSR) powered by Express.js. The project is bundled with Webpack and fully compatible with Node.js 14. It consumes the jsonplaceholder.typicode.com API. Routing is implemented in a way that allows users to share links and access the same content directly. The application includes user search and sorting by username, displays user posts and albums, and supports custom meta tags for SEO.",
        },

        {
            id: 70,
            companyId: 26,
            lang: "ru",
            project_name: "Portal",
            duration_work: "Февр 2024 - Май 2024",
            project_description:
                "Современный веб-сайт для кинотеатра с акцентом на удобство и визуальную привлекательность. Реализованы основные пользовательские страницы: главная, афиша, информация о фильмах, отзывы, покупка билетов, акции, контакты, личный кабинет с историей заказов и профилем пользователя. Проект выполнен в виде одностраничного приложения (SPA) с использованием React и Redux для динамичного интерфейса. Backend - на Laravel и MySQL с REST API. Продуманная структура данных, отзывчивый дизайн, взаимодействие с сервером в реальном времени - всё для того, чтобы пользователь мог легко искать фильмы, оставлять отзывы и оформлять заказы.",
        },
        {
            id: 71,
            companyId: 26,
            lang: "ua",
            project_name: "Portal",
            duration_work: "Лют 2024 - Трав 2024",
            project_description:
                "Сучасний веб-сайт для кінотеатру з акцентом на зручність та візуальну привабливість. Реалізовано основні сторінки користувача: головна, афіша, інформація про фільми, відгуки, купівля квитків, акції, контакти, особистий кабінет з історією замовлень та профілем користувача. Проект виконаний у вигляді односторінкової програми (SPA) з використанням React та Redux для динамічного інтерфейсу. Backend - на Laravel та MySQL з REST API. Продумана структура даних, чуйний дизайн, взаємодія з сервером у реальному часі – все для того, щоб користувач міг легко шукати фільми, залишати відгуки та оформляти замовлення.",
        },
        {
            id: 72,
            companyId: 26,
            lang: "en",
            project_name: "Portal",
            duration_work: "Feb 2024 - May 2024",
            project_description:
                "A modern cinema website focused on user convenience and visual appeal. Key user-facing pages were implemented, including the homepage, movie listings, film details, reviews, ticket purchasing, promotions, contact page, and a personal account section with order history and profile management. The project was developed as a Single Page Application (SPA) using React and Redux for a dynamic and responsive UI. The backend was built with Laravel and MySQL, communicating via a RESTful API. The application features a well-structured data model, responsive design, and real-time server interaction - all aimed at making it easy for users to browse movies, leave reviews, and purchase tickets.",
        },

        {
            id: 73,
            companyId: 27,
            lang: "ru",
            project_name: "Finance App",
            duration_work: "Май 2024 - Май 2024",
            project_description:
                "Небольшое приложение для отслеживания личных финансов, изначально созданное как пет-проект, а позже использованное в качестве курсовой работы в университете. Это одностраничное приложение (SPA), разработанное с использованием React.js и Redux, с системой авторизации и несколькими основными страницами. После входа в систему пользователь попадает на страницу профиля, главную страницу с отображением финансовой информации и операций, а также на страницу категорий. Можно вручную создавать категории и транзакции, привязывать категории к транзакциям, указывать сумму и дату. В качестве базы данных и бэкенда используется Firebase.",
        },
        {
            id: 74,
            companyId: 27,
            lang: "ua",
            project_name: "Finance App",
            duration_work: "Трав 2024 - Трав 2024",
            project_description:
                "Невеликий додаток для відстеження особистих фінансів, спочатку створений як пет-проект, а пізніше використаний як курсова робота в університеті. Це односторінковий додаток (SPA), розроблений з використанням React.js та Redux, з системою авторизації та кількома основними сторінками. Після входу в систему користувач потрапляє на сторінку профілю, головну сторінку з відображенням фінансової інформації та операцій, а також сторінку категорій. Можна вручну створювати категорії та транзакції, прив'язувати категорії до транзакцій, вказувати суму та дату. Як база даних і бекенд використовується Firebase.",
        },
        {
            id: 75,
            companyId: 27,
            lang: "en",
            project_name: "Finance App",
            duration_work: "May 2024 - May 2024",
            project_description:
                "A personal finance tracking app initially built as a side project and later used as a university coursework project. This is a Single Page Application (SPA) developed with React.js and Redux, featuring user authentication and several functional pages. After logging in, users can access a profile page, a main dashboard displaying financial statistics and operations, as well as a categories page. Users can manually create categories and transactions, assign categories to each transaction, and specify the amount and date. Firebase was used for both authentication and as the main cloud database and backend service.",
        },

        {
            id: 76,
            companyId: 28,
            lang: "ru",
            project_name: "Profile Person",
            duration_work: "Май 2024 - Май 2024",
            project_description:
                "Небольшое одностраничное приложение, разработанное на React с использованием Redux и Material UI. Приложение содержит страницу профиля с анимацией, редактируемыми данными и возможностью загрузки изображений. В качестве бэкенда использовался Laravel с базой данных MySQL",
        },
        {
            id: 77,
            companyId: 28,
            lang: "ua",
            project_name: "Profile Person",
            duration_work: "Трав 2024 - Трав 2024",
            project_description:
                "Невеликий односторінковий додаток, розроблений на React з використанням Redux та Material UI. Програма містить сторінку профілю з анімацією, редагованими даними та можливістю завантаження зображень. Як бекенд використовувався Laravel з базою даних MySQL.",
        },
        {
            id: 78,
            companyId: 28,
            lang: "en",
            project_name: "Profile Person",
            duration_work: "May 2024 - May 2024",
            project_description:
                "A small single-page application built with React, using Redux and Material UI. The app features a profile page with animations, editable user data, and image upload functionality. The backend was developed with Laravel and a MySQL database.",
        },

        {
            id: 79,
            companyId: 29,
            lang: "ru",
            project_name: "Bookshelf",
            duration_work: "Февр 2025 - Февр 2025",
            project_description:
                'Веб-приложение "Книжная полка", разработанное в рамках учебной практики. Проект реализован как SPA на Vue.js с использованием Vue Router, Pinia и json-server. В приложении предусмотрены регистрация и авторизация пользователей, просмотр, добавление, редактирование и удаление книг. Каждая книга включает название, автора, год издания и описание. Данные хранятся в моковой базе через RESTful API. Реализована валидация форм и переходы между страницами. Фронтенд размещён через Vercel, а данные сервера обрабатывались через render.com.',
        },
        {
            id: 80,
            companyId: 29,
            lang: "ua",
            project_name: "Bookshelf",
            duration_work: "Лют 2025 - Лют 2025",
            project_description:
                'Веб-додаток "Книжкова полиця", розроблений у рамках навчальної практики. Проект реалізований як SPA на Vue.js з використанням Vue Router, Pinia та json-server. У програмі передбачено реєстрацію та авторизацію користувачів, перегляд, додавання, редагування та видалення книг. Кожна книга включає назву, автора, рік видання та опис. Дані зберігаються у моковій базі через RESTful API. Реалізовано валідацію форм та переходи між сторінками. Фронтенд розміщено через Vercel, а дані сервера обробляли через render.com.',
        },
        {
            id: 81,
            companyId: 29,
            lang: "en",
            project_name: "Bookshelf",
            duration_work: "Feb 2025 - Feb 2025",
            project_description:
                '"Bookshelf" web application developed as part of an academic project. The project is implemented as a SPA using Vue.js, Vue Router, Pinia, and json-server. The app includes user registration and login, as well as functionality to view, add, edit, and delete books. Each book contains a title, author, publication year, and description. Data is managed via a mock RESTful API. Form validation and navigation between pages are also implemented. The frontend is deployed via Vercel, and the backend (mock API) is hosted on render.com.',
        },

        {
            id: 82,
            companyId: 30,
            lang: "ru",
            project_name: "Nexchance App",
            duration_work: "Июнь 2024 - Июль 2025",
            project_description:
                "Крупная ERP-система, предназначенная для управления различными аспектами бизнеса: товарооборотом, логистикой, интернет-магазинами, складским учётом, закупками, бухгалтерией и многим другим. Проект включал в себя огромное количество модулей, страниц, компонентов и элементов интерфейса - от аналитических панелей и таблиц до модальных окон, форм и вкладок. Архитектура проекта поддерживала высокую интерактивность на фронтенде в сочетании с надёжной и гибкой серверной частью. В разработке использовался широкий современный стек технологий: на бэкенде - Laravel и PostgreSQL, на фронтенде - Vue.js (с использованием Pinia и Vuetify), а также множество вспомогательных библиотек и инструментов для масштабируемой и удобной разработки. Система включала сложную бизнес-логику, глубокую интеграцию с базой данных (в том числе триггеры, процедуры, сотни таблиц), а также множество сторонних API. Также были реализованы современные подходы к архитектуре, стилю кода и развёртыванию - с использованием TypeScript, Sass, Tailwind, Vite/Webpack, ESLint, Prettier и CI/CD.",
        },
        {
            id: 83,
            companyId: 30,
            lang: "ua",
            project_name: "Nexchance App",
            duration_work: "Черв 2024 - Лип 2025",
            project_description:
                "Велика ERP-система, призначена для управління різними аспектами бізнесу: товарообігом, логістикою, інтернет-магазинами, складським обліком, закупівлями, бухгалтерією та багатьма іншими. Проект включав величезну кількість модулів, сторінок, компонентів і елементів інтерфейсу - від аналітичних панелей і таблиць до модальних вікон, форм і вкладок. Архітектура проекту підтримувала високу інтерактивність на фронтенді у поєднанні з надійною та гнучкою серверною частиною. У розробці використовувався широкий сучасний стек технологій: на бекенді - Laravel і PostgreSQL, на фронтенді - Vue.js (з використанням Pinia та Vuetify), а також безліч допоміжних бібліотек та інструментів для масштабованої та зручної розробки. Система включала складну бізнес-логіку, глибоку інтеграцію з базою даних (зокрема тригери, процедури, сотні таблиць), і навіть безліч сторонніх API. Також були реалізовані сучасні підходи до архітектури, стилю коду та розгортання – з використанням TypeScript, Sass, Tailwind, Vite/Webpack, ESLint, Prettier та CI/CD.",
        },
        {
            id: 84,
            companyId: 30,
            lang: "en",
            project_name: "Nexchance App",
            duration_work: "Jun 2024 - Jul 2025",
            project_description:
                "Large-scale ERP system designed to manage a wide range of business operations, including inventory turnover, logistics, online store integration, warehouse management, procurement, accounting, and more. The system included an extensive number of modules, pages, components, and interface elements - from dashboards and analytics to modal windows, complex tables, and multi-step forms. The architecture supported a highly dynamic and interactive frontend combined with a robust backend. The project utilized a diverse and modern tech stack: Laravel and PostgreSQL on the backend, Vue.js (along with Pinia and Vuetify) on the frontend, and various frontend tools and libraries to support scalable development. The system featured complex business logic, deep database integrations (including triggers, procedures, and hundreds of related tables), as well as multiple third-party API integrations. The application followed best practices in terms of code style, component organization, data flow, and deployment, using tools such as TypeScript, Sass, Tailwind, Vite/Webpack, ESLint, Prettier, and CI/CD pipelines.",
        },

        {
            id: 85,
            companyId: 31,
            lang: "ru",
            project_name: "GoSeeChat",
            duration_work: "Июль 2025 - Июль 2025",
            project_description:
                "Проект, представляющий собой полноценную социальную сеть. В системе реализованы такие функции, как новостная лента, публикации, фото и видео, обмен сообщениями, пользовательские профили, уведомления и многое другое. Моя задача заключалась в доработке некоторых блоков клиентской части. Работа велась с использованием React, Redux и JavaScript. Основной упор делался на разработку интерфейсов, взаимодействие с API и интеграцию функциональности в существующую архитектуру проекта.",
        },
        {
            id: 86,
            companyId: 31,
            lang: "ua",
            project_name: "GoSeeChat",
            duration_work: "Лип 2025 - Лип 2025",
            project_description:
                "Проект, що є повноцінною соціальною мережею. В системі реалізовані такі функції, як стрічка новин, публікації, фото і відео, обмін повідомленнями, профілі користувача, повідомлення та багато іншого. Моє завдання полягало у доопрацюванні деяких блоків клієнтської частини. Робота велася з використанням React, Redux та JavaScript. Основний акцент робився на розробку інтерфейсів, взаємодію з API та інтеграцію функціональності в існуючу архітектуру проекту.",
        },
        {
            id: 87,
            companyId: 31,
            lang: "en",
            project_name: "GoSeeChat",
            duration_work: "Jul 2025 - Jul 2025",
            project_description:
                "Project representing a full-fledged social network. The platform includes features such as a news feed, posts, photos and videos, messaging, user profiles, notifications, and more. My role involved refining and extending various frontend components. The work was done using React, Redux, and JavaScript, with a focus on building user interfaces, interacting with APIs, and integrating functionality into the existing project architecture.",
        },

        {
            id: 88,
            companyId: 32,
            lang: "ru",
            project_name: "Prelit",
            duration_work: "Июль 2025 - Авг 2025",
            project_description:
                "Платформа, предназначеная для поиска врачей и медучреждений. Реализованы страницы выбора врача и клиники, просмотр профилей, запись на приём, а также админ-панель с разделами для управления пользователями, врачами, приёмами и учреждениями. Участвовал в разработке клиентской части, где использовались React, JavaScript, TypeScript и Sass.",
        },
        {
            id: 89,
            companyId: 32,
            lang: "ua",
            project_name: "Prelit",
            duration_work: "Лип 2025 - Серп 2025",
            project_description:
                "Платформа, призначена для пошуку лікарів та медустанов. Реалізовано сторінки вибору лікаря та клініки, перегляд профілів, запис на прийом, а також адмін-панель з розділами для управління користувачами, лікарями, прийомами та установами. Брав участь у розробці клієнтської частини, де використовувалися React, JavaScript, TypeScript та Sass.",
        },
        {
            id: 90,
            companyId: 32,
            lang: "en",
            project_name: "Prelit",
            duration_work: "Jul 2025 - Aug 2025",
            project_description:
                "Platform designed to connect medical providers. The system includes clinic and doctor listings, appointment booking, profile views, and an admin panel for managing users, providers, appointments, and institutions. I contributed to the frontend development, where used React, JavaScript, TypeScript, and Sass.",
        },

        {
            id: 91,
            companyId: 33,
            lang: "ru",
            project_name: "Appify",
            duration_work: "Сент 2025 - Авг 2026",
            project_description:
                "Платформа для создания и управления PWA-приложениями в сфере iGaming. Я участвовал в разработке и развитии админ-панели, где реализованы инструменты для управления доменами, лендингами, push-уведомлениями, доступами и настройками приложений. Разрабатывал функционал предпросмотра (включая эмуляцию страницы Google Play) с динамическим обновлением данных в реальном времени. Также участвовал в интеграции с внешними сервисами и доработке серверной логики, включая работу с базой данных и автоматизацию процессов. Основной упор делался на разработку интерфейсов, улучшение UX и стабильное взаимодействие с API.",
        },
        {
            id: 92,
            companyId: 33,
            lang: "ua",
            project_name: "Appify",
            duration_work: "Вер 2025 - Серп 2026",
            project_description:
                "Платформа для створення та управління PWA-додатками у сфері iGaming. Я брав участь у розробці та розвитку адмін-панелі, де реалізовані інструменти для управління доменами, лендингами, push-повідомленнями, доступами та налаштуваннями додатків. Розробляв функціонал перегляду (включаючи емуляцію сторінки Google Play) з динамічним оновленням даних у реальному часі. Також брав участь в інтеграції із зовнішніми сервісами та доопрацюванні серверної логіки, включаючи роботу з базою даних та автоматизацію процесів. Основний упор робився на розробку інтерфейсів, покращення UX та стабільну взаємодію з API.",
        },
        {
            id: 93,
            companyId: 33,
            lang: "en",
            project_name: "Appify",
            duration_work: "Sep 2025 - Aug 2026",
            project_description:
                "A platform for creating and managing PWA applications in the iGaming industry. I participated in the development and enhancement of the admin panel, which includes tools for managing domains, landing pages, push notifications, access rights, and app settings. I developed preview functionality (including Google Play page emulation) with dynamic data updates in real time. I also participated in integration with external services and refined server logic, including database management and process automation. The main focus was on interface development, UX improvements, and stable API interaction.",
        },
    ],
};

const SET_CURRENT_PROJECT = "SET_CURRENT_PROJECT";

export const ProjectsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CURRENT_PROJECT:
            return { ...state, currentProject: action.payload };
        default:
            return state;
    }
};

export const setCurrentProjectAction = (payload) => ({
    type: SET_CURRENT_PROJECT,
    payload,
});
